import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
    MainTitle, Subtitle, 
    TextContent, HighlightText, 
    JsonCodeStyle,
} from '../../../Shared';
import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from './FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listQueryParams = [
  createData('lat','number', '-90 < lat < 90'),
  createData('lng','number', '-180 < lng < 180'),
];

const FindNearSegments = props => {
  const classes = useTableStyles();

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": [
      {
        "_id": 36723,
        "polyline": {
          "coordinates": [
            [106.6588507, 10.7677013],
            [106.659121, 10.7667349]
          ],
          "_id": "5f8bc17ffd75bf3cf2b19270",
          "type": "LineString"
        },
        "length": 111,
        "end_node": 4628119690,
        "start_node": 5757673277,
        "street": 220860894
      }
    ]
  }

  const responseErrors = {
    "code": 400,
    "message": "Bad input parameter",
    "errors": [
      {
        "reason": "invalid",
        "message": "Latitude: [-90,90]",
        "domain": "lat"
      }
    ],
    "debugError": {}
  }

  return (
    <div>
      <MainTitle>Find near segments</MainTitle>
      <TextContent>Find the segments that closest to a specified location.</TextContent>
      <Subtitle id="request-find-near-segments">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/segment/find-near</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>
      <TextContent><b><i>Query params:</i></b></TextContent>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listQueryParams.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{row.type}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-find-near-segments">Response</Subtitle>
      <Subtitle isSmall id="success-find-near-segments">Success</Subtitle>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/segment/find-near?lat=10.7674249&lng=106.6588025</HighlightText> </TextContent>
      <JsonCodeStyle data={responseSuccess} />

      <Subtitle isSmall id="success-find-near-segments">Errors</Subtitle>
      <TextContent>Bad input parameter</TextContent>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/segment/find-near?lat=110.7674249&lng=106.6588025</HighlightText> </TextContent>
      <JsonCodeStyle data={responseErrors} />

      <StyledSeparated />
    </div>
  )
}

FindNearSegments.propTypes = {

}

export default FindNearSegments
